<script setup lang="ts">
import PageViewWrapper from '@/views/PageViewWrapper.vue'
import { useRouter, RouterView } from 'vue-router'

import { onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const router = useRouter()

onMounted(() => {
  if (
    ['AnalyzeHandsV3', 'AnalyzeFilesV4', 'GtoReports', 'AnalyzeHandsV4'].some(
      route => router.currentRoute.value.name === route,
    )
  ) {
    return
  }

  if (store.getters.user_has_flag('HHV2')) {
    router.push('/analyze/v3/hands')
  } else {
    router.push('/analyze/hands')
  }
})
</script>

<template>
  <PageViewWrapper :isStretched="!!$route.meta.pageViewStretched">
    <router-view :key="$route.name || 'analyze'"></router-view>
  </PageViewWrapper>
</template>
